export default __webpack_public_path__ + "static/media/Nunito-Black.4d32dbe3.woff";